<template>
  <div class="" v-if="entry">
    <div class="min-h-screen bg-rndigo-100  flex items-center justify-center text-gray-700">
      <div class="w-full">
        
        <div>
          <div id="main" class="px-8 bg-white grid grid-cols-1 lg:grid-cols-12 gap-x-10 gap-y-1 p-5 pb-20 border-gray-200">
            <div class="col lg:col-span-12 order-1">
              <p class="text-md  text-fuchsia-500  pt-10 mb-3">
                <router-link :to="{ name: 'home' }">← Strona główna</router-link>
              </p>
            </div>
            <div class="col lg:col-span-8 order-3 lg:order-2">
              <p v-if="entry.date_bc" class="text-sm text-gray-500 pt-10 mb-3">
                {{ entry.date_bc }} p.n.e.
              </p>
              <p v-else class="text-sm text-gray-300 pt-10 mb-3">
                {{ entry.date }}
              </p>
              <h2 class="text-xl text-fuchsia-500 mb-3">
                <prismic-rich-text v-if="entry" :field="entry.speaker" />
              </h2>
              <h2 class="text-3xl font-semibold mb-10 font-display text-black">
                <prismic-rich-text v-if="entry" :field="entry.title" />
              </h2>
              
              <prismic-rich-text class="text leading-normal" :field="entry.description" />
            </div>
            
            <div class="col  lg:col-span-4 order-2 lg:order-3 ">
              <prismic-image v-if="entry" id="key-image" class="lg:mx-auto w-10/12 rounded-3xl lg:mt-10 " :field="entry.image"/>
              <span class="text-white text-sm ml-24">{{ entry.photo_attribution }}</span>
            </div>
          </div>
          
          <div name="navigation" id="anchorpoint" class="bg-white sticky top-0 z-20 border-gray-200 flex flex-col lg:flex-row justify-center lg:justify-start border-b-2 border-gray-200">
            <button v-for="(tab, index) in tabs"
                    class="cursor-pointer text-gray-600 lg:py-6 lg:px-6 block hover:bg-fuchsia-200 focus:outline-none"
                    :class="activeTab===index ? 'border-b-2 font-medium border-fuchsia-500' : ''"
                    @click="switchTab(tab.id, index)">{{tab.label}}</button>
          </div>
          
          <div id="transcript" class="bg-white lg:m-4 py-8 px-10  md:grid grid-cols-1 lg:grid-cols-12 md:space-y-0 space-y-1  shadow-md lg:rounded-3xl">
            <div class="col-span-8">
              <h2 class="text-xl font-bold my-6 font-display text-black">Przemówienie</h2>
              
              <div v-if="this.videos[0].show" class="pb-3 space-y-1">
                <youtube :fitParent="true" :video-id="this.videos[0].id" ref="transcriptYoutube"></youtube>
              </div>
              
              <div class="space-y-1 pb-6">
                <div class=" w-full overflow-hidden"
                     v-bind:class="[ truncateText.transcript ? 'line-clamp-18' : '' ]"
                     v-bind:style="[ truncateText.transcript ? {'mask-image': 'linear-gradient(to bottom, black 50%, transparent 100%)'} : {} ]"
                     v-on:click="toggleEllipsis(0)">
                  <prismic-rich-text class="" :field="entry.transcript" />
                </div>
                <div class="w-full  text-center">
                  <button
                    v-on:click="toggleEllipsis(0)"
                    v-bind:style="[ truncateText.transcript ? {} : {'display': 'none'}  ]"
                    class="text-white px-4 py-2 w-auto  text-fuchsia-500 lg:rounded-full bg-white transition ease-in duration-200 focus:outline-none">
                    <svg class="w-8 h-8 stroke-current inline-block " xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="bevel"><path d="M7 13l5 5 5-5M7 6l5 5 5-5"/> </svg><span>Rozwiń</span>
                  </button>
                </div>
              </div>
              <div x-if="entry.reference_links" class="pb-6 space-y-1">
                <div v-for="ref in entry.reference_links">
                  <ReferenceButton :title="ref.link_title" :link="ref.link_url" />
                </div>
              </div>
            </div>
          </div>
          
          <div id="analysis" v-if="show.analysis" class="bg-white lg:m-4 py-8 px-10   md:grid grid-cols-1 lg:grid-cols-12 gap-x-10 gap-y-1 px-4 shadow-md lg:rounded-3xl">
            <div class="col-span-8">
              <h2 class="text-xl font-bold my-6 font-display text-black">Analiza</h2>
              <div class=" w-full overflow-hidden"
                   v-bind:class="[ truncateText.analysis ? 'line-clamp-18' : '' ]"
                   v-bind:style="[ truncateText.analysis ? {'mask-image': 'linear-gradient(to bottom, black 50%, transparent 100%)'} : {} ]"
                   v-on:click="toggleEllipsis(1)">
                <prismic-rich-text class="text  mb-3" :field="entry.analysis_body"/>
              <div class="text-gray-600 text-left">{{entry.analysis_author}}</div>
              </div>
                <div class="w-full  text-center">
                  <button
                    v-on:click="toggleEllipsis(1)"
                    v-bind:style="[ truncateText.analysis ? {} : {'display': 'none'}  ]"
                    class="text-white px-4 py-2 w-auto  text-fuchsia-500 lg:rounded-full bg-white transition ease-in duration-200 focus:outline-none">
                    <svg class="w-8 h-8 stroke-current inline-block " xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="bevel"><path d="M7 13l5 5 5-5M7 6l5 5 5-5"/> </svg><span>Rozwiń</span>
                  </button>
                </div>
            </div>
            <div class="col-span-4">
              <div v-if="this.videos[1].show" class="pb-3 mt-20">
                <youtube :fitParent="true" :video-id="this.videos[1].id" ref="analysisYoutube"></youtube>
              </div>
            </div>
          </div>
          
          <div id="shop" v-if="show.quotes" class="bg-white lg:m-4 py-8 px-10  md:grid grid-cols-1 lg:grid-cols-12 gap-x-10 gap-y-1 px-4 shadow-md lg:rounded-3xl">
            <div class="col-span-8">
              <h2 class="text-xl font-bold my-6 font-display text-black">Cytaty i ciekawostki</h2>
              
              <h2 class="text-sm font-bold mb-4 font-display text-black">Poznaj ważne cytaty i ciekawostki</h2>
              
              <PictureBox v-for="(q, index) in entry.quotes"
                          :key="index"
                          :body="q.body"
                          :canDownload="q.can_be_downloaded"
                          :image="q.linked_image" />
              
            </div>
            <div v-if="show.shop" class="col-span-4">
              <h2 class="text font-bold my-4 mt-20 font-display text-black">Zobacz powiązane produkty w naszym sklepie</h2>
              <ShopBox v-for="(p, index) in entry.related_products"
                       :key="index"
                       :body="p.product_name"
                       :price="p.price"
                       :image="p.product_image"
                       :link="p.shop_link" />
            </div>
          </div>
          
          <div id="training" v-if="this.videos[2].show"  class="bg-white lg:m-4 py-8 px-10  md:grid grid-cols-1 lg:grid-cols-12 gap-x-10 gap-y-1 px-4 shadow-md lg:rounded-3xl">
            <div class="col-span-8">
              <h2 class="text-xl font-bold my-6 font-display text-black">Trenuj</h2>
              <div v-if="this.videos[2].show" class="">
                <youtube :fitParent="true" :video-id="this.videos[2].id" ref="trainingYoutube"></youtube>
              </div>
            </div>
            
            <div class="col-span-4">
              <h2 class="text-sm font-bold mb-4 mt-20 font-display text-black">Jak to działa?</h2>
              <p class="mb-4">
                Olbrzymia część współczesnych mówców odczytuje swoje przemówienia z promptera. Podczas dużych wystąpień niektórzy mają nawet takie 3 urządzenia - w 3 różnych miejscach sali:)
              </p><p>
                Poczuj się, jak oni i wygłoś to przemówienie, korzystając z nagrania obok. Wystartuj je i przeczytaj. Tempo i wielkość czcionki są uniwersalne. Możesz się nagrać - aby zobaczyć różnicę między Twoją interpretacją, a oryginałem:) Dobrej zabawy!
              </p>
            </div>
          </div>
          
          <div id="related" v-if="show.related" class="bg-white lg:m-4 py-8 px-10  md:grid md:grid-cols-12 gap-x-10 gap-y-1 px-4 shadow-md lg:rounded-3xl">
            <div class="col-span-12">
              <h2 class="text-xl font-bold mt-8 mb-8 font-display text-black">Przemówienia, które mogą Cię zainteresować</h2>
            </div>
            <div class="col-span-12">
              <div class="md:grid md:grid-cols-3 gap-6 ">
                
              </div>
            </div>
          </div>
          
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReferenceButton from './Entry/ReferenceButton.vue'
import MediaTile from './Entry/MediaTile.vue'
import PictureBox from './Entry/PictureBox.vue'
import ShopBox from './Entry/ShopBox.vue'

export default {
    name: 'Entry',
    data() {
        return {
            entry: null,
            transcriptVideoId: null,
            truncateText:{ analysis: true, transcript: true },
            transcriptVideoShow: false,
            show: {
                shop: false,
                quotes: false,
                analysis: false,
                related: false
            },
            videos:[
                {
                    name: 'transcript',
                    show: false,
                    url: null,
                    id: null
                },
                {
                    name: 'analysis',
                    show: false,
                    url: null,
                    id: null
                },
                {
                    name: 'train',
                    show: false,
                    url: null,
                    id: null
                }
            ],
            activeTab: false,
            tabs: [
                { label: "Przemówienie",
                  id: "transcript"
                },
                { label: "Analiza",
                  id: "analysis"
                },
                { label: "Cytaty i ciekawostki",
                  id: "shop"
                },
                { label: "Trenuj",
                  id: "training"
                }
            ]
        }
    },
    components:{
        ReferenceButton, MediaTile, PictureBox, ShopBox
    },
    methods: {
        async loadEntry() {
            const response = await this.$prismic.client.getByID(this.$route.params.id, {})
            this.entry = response.data;
            this.displayChecks();
            this.loadVideos();
        },
        displayChecks(){
            if(this.entry.related_products && this.entry.related_products.length > 0) this.show.shop = true
            if(this.entry.quotes && this.entry.quotes.length > 0) this.show.quotes = true
            if(this.entry.analysis_body && this.entry.analysis_body.length > 0) this.show.analysis = true
        },
        async loadVideos(){
            if(this.entry.link_recording.url){
                this.videos[0].url = this.entry.link_recording.url
            };
            if(this.entry.analysis_video.url){
                this.videos[1].url = this.entry.analysis_video.url
            };
            if(this.entry.training_video.url){
                this.videos[2].url = this.entry.training_video.url
            };
            var y = this.$youtube;
            this.videos.forEach(function(v,i) { 
                var longUrl = v.url;
                var shortId = y.getIdFromUrl(longUrl)
                if(shortId){
                    // console.log(`Got transcript video id - ${shortId}`)
                    v.id = shortId;
                    v.show = true;
                }else{
                    // console.log(`No video found for- ${v.name}`)
                }
            }) 
        },
        toggleEllipsis(n) {
            if(n == 0){
                this.truncateText.transcript = !this.truncateText.transcript;
            }else{
                this.truncateText.analysis = !this.truncateText.analysis;
            }
            
        },
        switchTab(n,i){
            this.activeTab = i;

            let element = document.getElementById(n);
            element.scrollIntoView({behavior: "smooth", block: "start"});
        }
    },
    created() {
        this.loadEntry()
    }
}
</script>

<style >
#key-image{
    box-shadow:         28px 28px 0px 0px #A8278F;
}
p{
    margin-bottom:1em;
}
</style>
